/* eslint-disable max-len */
class GoogleMapsApi {
    constructor(API_KEY, LIBRARIES) {
        this.API_KEY = API_KEY;
        this.LIBRARIES = LIBRARIES !== undefined ? LIBRARIES : false;

        if (!window.GoogleMapsApi) {
            this.callbackName = 'GoogleMapsApi.mapLoaded';
            window.GoogleMapsApi = this;
            window.GoogleMapsApi.mapLoaded = this.mapLoaded.bind(this);
        }
    }

    load() {
        if (!this.promise) {
            this.promise = new Promise((resolve) => {
                this.resolve = resolve;

                if (typeof window.google === 'undefined') {
                    const script = document.createElement('script');

                    if (this.LIBRARIES) {
                        const param = this.LIBRARIES.join(',');
                        const locale = document.documentElement.lang;
                        script.src = `//maps.googleapis.com/maps/api/js?key=${this.API_KEY}&libraries=${param}&language=${locale}&callback=${this.callbackName}`;
                    } else {
                        script.src = `//maps.googleapis.com/maps/api/js?key=${this.API_KEY}&callback=${this.callbackName}`;
                    }
                    script.async = true;
                    document.body.append(script);
                } else {
                    this.resolve();
                }
            });
        }

        return this.promise;
    }

    mapLoaded() {
        if (this.resolve) {
            this.resolve();
        }
    }
}

export { GoogleMapsApi };
